import { type File } from 'gpcore-grpc/gpcore/type/v1/file_pb';

const bufferToBase64 = (u8: Uint8Array): string => {
  return btoa(String.fromCharCode.apply(null, u8 as unknown as number[]));
};

export const toBase64 = (file: File) => bufferToBase64(file.bytes);

export const toImageSrc = (file: File) => `data:${file.mimeType};base64,${toBase64(file)}`;
